import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";
import {
  AccessAlarm
} from "@material-ui/icons";
import styled from "styled-components";

const TimerContainer = styled.div`
  height: 40px;
  position: relative;
  width: 40px;
`;

const Timer = styled(AccessAlarm)`
  color: rgba(0, 0, 0, 0.5);
  left: 8px;
  position: absolute;
  top: 8px;
`;

export const UpdateTimer = (props) => {
  const { minutes, seconds, updateFunction } = props;

  let ms;
  const interval = 1000;

  const [ timeTaken, setTimeTaken ] = useState(0);

  if (minutes) {
    ms = minutes * 60 * 1000;
  } else {
    ms = seconds * 1000;
  }

  useEffect(() => {
    if (timeTaken > ms) {
      updateFunction();
      setTimeTaken(0);
    } else {
      setTimeout(() => {
        setTimeTaken(timeTaken + interval);
      }, interval);
    }
  }, [timeTaken, seconds, updateFunction, ms]);

  return (
    <TimerContainer>
      <CircularProgress variant="static" value={(timeTaken / ms) * 100} />
      <Timer />
    </TimerContainer>
  );
};

UpdateTimer.propTypes = {
  /** The number of minutes between calls to the update function. If minutes aren't passed, then `seconds` will be used */
  minutes: PropTypes.number,
  /** The number of seconds between calls to the update function. Will not be used if `minutes` is passed in. */
  seconds: PropTypes.number,
  /** The function to call at the regular interval */
  updateFunction: PropTypes.func
};
